import React, { FC, memo } from 'react';
import { ProductsInfo } from '@/common/components/Products/types';
import ScrollingIntroLayout, { ScrollingIntroLayoutProps } from '@/common/layouts/ScrollingIntroLayout/ScrollingIntroLayout';
import Products from '@/common/components/Products/Products';
import classNames from 'classnames';
import styles from './WhatWeDoPage.module.scss';

interface WhatWeDoPageProps extends ScrollingIntroLayoutProps, ProductsInfo {
}

const WhatWeDoPage: FC<WhatWeDoPageProps> = memo(({
  products = [],
  ...scrollingIntroProps
}: WhatWeDoPageProps) => {
  const whatWeDoProducts = [...products];
  whatWeDoProducts[0].customClassNames = {
    container: styles.product,
    textBlock: styles.text,
    images: {
      container: styles.imagesContainer,
      large: classNames(styles.largeImageBlock, styles.adviseProductLargeImageBlock),
      small: classNames(styles.smallImageBlock, styles.adviseProductSmallImageBlock),
    },
  };
  whatWeDoProducts[1].customClassNames = {
    container: styles.product,
    textBlock: styles.text,
    images: {
      container: styles.imagesContainer,
      large: styles.largeImageBlock,
      small: classNames(styles.smallImageBlock, styles.solveProductSmallImageBlock),
    },
  };
  whatWeDoProducts[2].customClassNames = {
    container: styles.product,
    images: {
      container: styles.deliverProductImagesContainer,
      large: styles.deliverProductLargeImageBlock,
      small: styles.deliverProductSmallImageBlock,
    },
  };

  return (
    <ScrollingIntroLayout {...scrollingIntroProps}>
      <Products
        products={whatWeDoProducts}
        isImagesFullWidthMobile
        isImagesNotFullWidthDesktop
      />
    </ScrollingIntroLayout>
  );
});

export default WhatWeDoPage;
